module.exports = __webpack_public_path__ + "img/lewisham-logo.df7cc0ff.svg";